import { Box } from '@mui/system';

import AdditionalServiceTile from './AdditionalServiceTile';
import NoAdditionalServiceTile from './NoAdditionalServiceTile';
import { useServer } from '../Server/ServerContext';
import Subtitle from '../AppHeadBar/Subtitle';
import appFunctions from '../../AppFunctions';

import { AdditionalService, Styles } from '../../Types';
import React from 'react';

const styles = {
  servicesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: (theme) => theme.spacing(1),
    paddingTop: (theme) => theme.spacing(6),
    boxSizing: 'border-box',
    justifyContent: 'flex-end',
  },
} as Styles;

export default function AdditionalServiceWrapper() {
  const { service } = appFunctions.getSelection(useServer());

  const servicesMap = [...service.additionalServices]
    .sort((a, b) => a.additional_service_category_index - b.additional_service_category_index)
    .reduce(
      (acc, additionalService) =>
        acc.set(additionalService.additional_service_category_index, [
          ...(acc.get(additionalService.additional_service_category_index) || []),
          additionalService,
        ]),
      new Map<number, AdditionalService[]>(),
    );

  const [currentCategoryIndex, setCurrentCategoryIndex] = React.useState(Math.min(...servicesMap.keys()) || 0);

  const lastCategory = Math.max(...servicesMap.keys());
  const currentCategoryAdditionalServices = servicesMap.get(currentCategoryIndex) || [];
  const noAdditionalServiceText =
    currentCategoryAdditionalServices[0]?.noAdditionalServiceText || 'Keine Zusatzleistung';

  const [selectedAdditionalServices, setSelectedAdditionalServices] = React.useState<AdditionalService[]>([]);

  return (
    <>
      <Subtitle>{service.name}</Subtitle>

      <Box sx={styles.servicesWrapper}>
        <NoAdditionalServiceTile
          text={noAdditionalServiceText}
          key={0}
          onSelect={() => {
            const isLastCategory = currentCategoryIndex === lastCategory;
            if (!isLastCategory) {
              setCurrentCategoryIndex((prev) => prev + 1);
            } else {
              appFunctions.selectAdditionalService(selectedAdditionalServices);
            }
          }}
        />
        {currentCategoryAdditionalServices.map((additionalService) => (
          <AdditionalServiceTile
            key={additionalService.id}
            additionalService={additionalService}
            onSelect={() => {
              const isLastCategory = currentCategoryIndex === lastCategory;
              if (!isLastCategory) {
                setCurrentCategoryIndex((prev) => prev + 1);
                setSelectedAdditionalServices((prev) => [...prev, additionalService]);
              } else {
                appFunctions.selectAdditionalService([...selectedAdditionalServices, additionalService]);
              }
            }}
          />
        ))}
      </Box>
    </>
  );
}
